import React from 'react';
import './index.scss'

export default function StartegicImperativeIcon ({component}) {
    const {highlightedColor} = component;

    const fillColor = (
        highlightedColor === 'Teal' ? 
        '#18988B' : 
        highlightedColor === 'Magenta' ? 
        '#FD495C' : 
        highlightedColor === 'Purple' ? 
        '#655DC6' :
        highlightedColor === 'Grey' ? 
        '#6E7491' : '#BCB5B5'
    )
    return (
    <div className={`stratIcon ${highlightedColor}`}>
        <svg width="76" height="73" viewBox="0 0 76 73" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1,35a18,19 0 1,0 36,0a18,19 0 1,0 -36,0" opacity='0.3' fill='#BCB5B5'/>
        <path d="M39,35a18,19 0 1,0 36,0a18,19 0 1,0 -36,0" opacity='0.3' fill='#BCB5B5'/>
        <path d="M19,54.5a19.5,18.5 0 1,0 39,0a19.5,18.5 0 1,0 -39,0" opacity='0.3' fill='#BCB5B5' />
        <path d="M57 19C57 28.9168 48.7419 37 38.5 37C28.2581 37 20 28.9168 20 19C20 9.0832 28.2581 1 38.5 1C48.7419 1 57 9.0832 57 19Z" fill={fillColor} stroke="#fff" stroke-width="2" opacity="1"/>
        </svg>
    </div>
    )
}